export default "__VITE_ASSET__3a12924d__"